import { render, staticRenderFns } from "./ClientPrototypeItemList.vue?vue&type=template&id=389c5410&scoped=true"
import script from "./ClientPrototypeItemList.vue?vue&type=script&lang=js"
export * from "./ClientPrototypeItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c5410",
  null
  
)

export default component.exports